import i18n from "i18n";

export const initialCroppedImages = ({
  roadProblemPicture = null,
  extraPicture = null,
  offencePicture = null,
  licenseNumberPicture = null,
}: {
  roadProblemPicture: string | null;
  extraPicture: string | null;
  offencePicture: string | null;
  licenseNumberPicture: string | null;
}) => [
  {
    name: "licenseNumberPicture",
    src: licenseNumberPicture,
    text: i18n.t("croppedImageText1"),
    backgroundColor: "#1E1E1E", // $brand-black (elements.scss)
  },
  {
    name: "offencePicture",
    src: offencePicture,
    backgroundColor: "#1E1E1E", // $brand-black (elements.scss)

    text: i18n.t("croppedImageText2"),
  },
  {
    name: "extraPicture",
    text: i18n.t("croppedImageText3"),
    backgroundColor: "#1E1E1E", // $brand-black (elements.scss)
    src: extraPicture,
  },
  {
    name: "roadProblemPicture",
    text: i18n.t("croppedImageText4"),
    backgroundColor: "#1E1E1E", // $brand-black (elements.scss)
    src: roadProblemPicture,
  },
];
